<template>
	<div class="">
		<div class="cause7_wpcm-recurring-btns">
			<ul class="d-inline-flex" v-if="show_recurring">
				<li class="m-0 " v-if="strings" @click.prevent="store.recurring = true">

					<a href="#" :class="store.recurring && 'active'"><svg width="14" height="14" viewBox="0 0 24 24"
							fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M12 20C28.659 10.9628 18.2615 0.617428 12 6.95101C5.73851 0.617357 -4.659 10.9627 12 20Z"
								fill="currentColor"></path>
						</svg>{{
							strings.recurring
						}}</a>
				</li>
				<li class="m-0" v-if="strings" @click.prevent="store.recurring = false">
					<a href="#" :class="!store.recurring && 'active'">{{
						strings.one_time
					}}</a>
				</li>
			</ul>
		</div>
		<div class="wpcm-payment-gateways mt-3">
			<div class="mb-3">
				<ul class="wpcm-gateway-list" v-if="gateways">
					<li v-for="(gateway, gateway_id) in gateways" :key="gateway_id">
						<a @click.prevent="setValue('payment_method', gateway.id)"
							:class="[(gateway.id === store.payment_method) && 'active']" title="" href="#">
							<span v-if="gateway.icon"><img :src="gateway.icon" alt=""></span>
							{{
								gateway.title ? gateway.title : gateway.name
							}}</a>
					</li>
				</ul>
			</div>

			<div
				class="wpcm-gateway-testing-info mb-3"
				v-if="selectedTestingInfo"
			>
				<div
					class="wpcm-gateway-testing-info__text"
					v-html="selectedTestingInfo"
				></div>
			</div>

			<slot name="gateway_data"></slot>
			<slot name="billing_info"></slot>
			<slot></slot>
		</div>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useDonationFormsStore } from '../../store';

const store = useDonationFormsStore();
const props = defineProps(["gateways", "show_recurring", "strings"]);

const setValue = (key, val) => {
	store[key] = val;
};

const selectedTestingInfo = computed(() => {
	const selected = store.payment_method;
	if (!selected || !props.gateways) return '';
	const list: any = props.gateways;
	const match: any = Array.isArray(list)
		? list.find((g: any) => g && g.id === selected)
		: Object.values(list).find((g: any) => g && g.id === selected);
	return (match && match.testing_info) ? match.testing_info : '';
});

const getBack = () => {
};


</script>